<template>
    <!-- 组合 -->
    <div class="transpond_simulation_content" @click.stop.prevent="handleClickGroupDetail">
        <div class="transpond_title">
            <p
                :class="['simulation_stock_info', isGoUp(msg.profit_rate) ? 'to_red' : 'to_green']">
                <span>{{ msg.profit_rate }}%</span>
                <span>总收益</span>
            </p>
        </div>
        <div class="transpond_detail">
            <div class="transpond_list">
                <p class="simulation">
                    <span>{{ msg.group_name }}</span>
                </p>
                <div class="simulation_info_right">
                    <p>
                        <span v-if="type == 'normal' || type == 'forwardShare'">{{ msg.max_stock_position_name }}</span>
                        <span v-else-if="type == 'forward'">近期讨论：{{ msg.comment_num }}条</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="attention_box">
            <div
                :class="['attention_btn', {
                    is_follow: is_follow === 'yes'
                }]"
                v-if="is_follow === 'no' || is_follow === 'yes'"
                @click.stop.prevent="followGroup"
            >{{ is_follow === 'yes'? '已关注': '关注' }}</div>
            <p class="attention_box_follow_nums">{{ follow_num }}人关注</p>
        </div>
    </div>
</template>
<script>
import { u_id } from "@/utils/urlQuery";
import { isGoUp, isLoginInfo } from "@/utils/index";
import userHomeApi from "@/api/user_home/index.js";
import { Toast, Dialog } from 'vant';
export default {
    name: "stockGroup",
    props: {
        msg: {
            type: Object,
            default: () => {
                return {}
            }
        },
        type: {
            type: String,
            default: "normal"
        }
    },
    data() {
        return {
            u_id,
            is_follow: "no",
            follow_num: 0,
            loading: false,
        }
    },
    created() {
        let msg = this.msg;
        this.is_follow = msg.is_follow;
        this.follow_num = msg.follow_num;
    },
    methods: {
        // 点击【已关注、关注】组合按钮
        async followGroup() {
			if(!isLoginInfo()) {
				return
			}
            if(this.loading) {
                return
            }
            this.loading = true;
            let status = this.is_follow;
            if(status == 'yes') {
                status = 'no';
            } else {
                status = 'yes';
            }
            
            if(this.u_id == this.msg.id && status == 'no') {
                Toast({
                    type: "html",
                    message: "<div class='stockGroupTips'>不能取消关注自己的模拟炒股</div>",
                    position: "bottom"
                })
                this.loading = false;
                return;
            }

            let res = await userHomeApi.setStockFollow({
                g_id: this.msg.id,
                status: status
            })
            if(res.rslt == 'succ') {
                this.is_follow = status;
                if(status == 'yes') {
                    this.follow_num += 1;
                    Dialog.alert({
                        title: '提示',
                        message: '订阅成功，调仓记录会第一时间推送！订阅后可在“模拟炒股-我订阅的组合”中查看',
                    }).then(() => {
                        // on close
                    });
                } else {
                    if(this.follow_num - 1 <= 0) {

                    } else {
                        this.follow_num -= 1;
                    }
                    Toast({
                        type: "html",
                        message: "<div class='stockGroupTips'>取消关注成功</div>",
                        position: "bottom"
                    })
                }
            }
            this.loading = false;
        },
        handleClickGroupDetail() {
            this.openNative("group_detail_page")
        },
        // 跳转APP页面
        openNative(type) {
            let params = {
                kind: type, // 类型
            };

            switch (type) {
                case "group_detail_page": // K线训练营
                    break;
            }

            this.$srH5CallNativeMethodApp('call_Native', params)
        },
    }
}
</script>
<style scoped lang="scss">
@import "~@/assets/sass/global.scss";
.transpond_simulation_content {
    height: rem2(60px);
    padding: rem2(6px) rem2(12px) rem2(6px) rem2(6px);
    background: rgba(255, 255, 255, 1);
    border-radius: rem2(10px);
    border: rem2(1px) solid rgba(245, 245, 245, 1);
    display: flex;
    box-sizing: border-box;
    box-shadow: rem2(0px) rem2(0px) rem2(14px) rem2(0px) rgba(67, 67, 67, 0.07);

    .transpond_title {
        width: rem2(85px);
        height: rem2(48px);
        margin-right: rem2(10px);

        .simulation_stock_info {
            height: rem2(48px);
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            box-sizing: border-box;

            &.to_green {
                background: url(https://cdncos.aigupiao.com/assets/pc/img/bg_group_down.png);
                background-size: 100%;
            }

            &.to_red {
                background: url(https://cdncos.aigupiao.com/assets/pc/img/bg_group_up.png);
                background-size: 100%;
            }

            >span {
                display: block;
                color: #ffffff;
                font-size: rem2(11px);
                width: 100%;
                text-align: center;

                &:first-child {
                    font-size: rem2(15px);
                    // font-weight: bold;
                }
            }
        }
    }

    .transpond_detail {
        height: 100%;
        flex: 1;

        .transpond_list {
            height: 100%;

            display: flex;
            flex-direction: column;
            justify-content: space-around;
            font-size: rem2(15px);
        }

        .simulation_info_right {
            font-size: rem2(12px);
            color: #9f9f9f;

            >p {
                display: flex;
                align-items: center;
            }
        }
    }

    .attention_box {
        height: 100%;
        flex-direction: column;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding: rem2(2px) 0;
        box-sizing: border-box;

        .attention_btn {
            width: rem2(44px);
            height: rem2(20px);
            background: rgba(255, 255, 255, 1);
            border-radius: rem2(3px);
            border: rem2(1px) solid rgba(254, 72, 74, 1);
            color: #fe484a;
            font-size: rem2(12px);
            text-align: center;
            line-height: rem2(20px);

            &.is_follow {
                color: #9f9f9f;
                border-color: #cfcfcf;
            }
        }

        >p {
            color: #9f9f9f;
            font-size: rem2(12px);
        }

        .attention_box_follow_nums {
            margin-top: rem2(3px);
            line-height: rem2(16px);
            color: #939393; 
        }
    }
}
</style>
<style>
.stockGroupTips {
    white-space: nowrap;
}
</style>